// constants
import { ReportsActionTypes } from "./constants";

export interface ReportsActionType {
  type:
    | ReportsActionTypes.API_RESPONSE_SUCCESS
    | ReportsActionTypes.API_RESPONSE_ERROR
    | ReportsActionTypes.GET_RENTALS_REPORT
    | ReportsActionTypes.GET_REVENUE_REPORT
    | ReportsActionTypes.GET_LOCATION_REPORT;

  payload: {} | string;
}

// Common success
export const ReportsApiResponseSuccess = (actionType: ReportsActionTypes, data: any | {}): ReportsActionType => ({
  type: ReportsActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// Common error
export const ReportsApiResponseError = (actionType: ReportsActionTypes, error: string): ReportsActionType => ({
  type: ReportsActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

// Get rentals report
export const getRentalsReport = (
  type: string,
  startDate?: any,
  endDate?: any,
  packageType?: any,
  rentalStatus?: any,
  paymentStatus?: any,
  locationId?: any,
  corporateId?: any,
  page?: number,
  limit?: number,
  userId?: any,
  show_deleted?: boolean
): ReportsActionType => ({
  type: ReportsActionTypes.GET_RENTALS_REPORT,
  payload: {
    type,
    startDate,
    endDate,
    packageType,
    rentalStatus,
    paymentStatus,
    locationId,
    corporateId,
    page,
    limit,
    userId,
    show_deleted,
  },
});

export const getRevenueReport = (
  type: string,
  startDate?: any,
  endDate?: any,
  packageType?: any,
  locationId?: any,
  corporateId?: any,
  page?: number,
  limit?: number,
  userId?: any,
  show_deleted?: boolean
): ReportsActionType => ({
  type: ReportsActionTypes.GET_REVENUE_REPORT,
  payload: {
    type,
    startDate,
    endDate,
    packageType,
    locationId,
    corporateId,
    page,
    limit,
    userId,
    show_deleted,
  },
});

// Get devices report
export const getLocationsReport = (type: string): ReportsActionType => ({
  type: ReportsActionTypes.GET_LOCATION_REPORT,
  payload: {
    type,
  },
});
